import { render } from "./ReportsBarChart.vue?vue&type=template&id=b7b17c28&scoped=true"
import script from "./ReportsBarChart.vue?vue&type=script&lang=js"
export * from "./ReportsBarChart.vue?vue&type=script&lang=js"

import "./ReportsBarChart.vue?vue&type=style&index=0&id=b7b17c28&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dxworks\\Downloads\\dpp_adm_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7b17c28"]])

export default __exports__